import { TranslationRepository } from '../data/translation-repository';
import { TranslationKey, CreateTranslationRequest } from '../types/translation-types';

export class CreateTranslationUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(data: CreateTranslationRequest): Promise<TranslationKey> {
    return this.repository.create(data);
  }
}
